<template>
  <div>
    <v-list>
      <!-- DASHBOARD -->
      <!-- <v-tooltip right>
        <v-list-tile :to="{path: '/dashboard'}" ripple slot="activator" :class="{'list__tile--active-router' : '/dashboard' == $route.matched[1].path}">
          <v-list-tile-action>
            <v-icon :class="{'secondary--text' : '/dashboard' == $route.matched[1].path}">dashboard</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <span>{{ $t('dashboard') | cap }}</span>
      </v-tooltip> -->
      <!-- TRAFIC -->
      <v-tooltip right v-if="checkPermission('NO_ADMINS') || isLevelEntreprise">
        <v-list-tile 
          :to="pathTrafic"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/trafic' == $route.matched[1].path}">
          <v-list-tile-action>
            <v-badge
              right
              color="primary"
              v-model="$store.state._StoreWatcheeBox.listeAllVisiteurs.length"
            >
              <small slot="badge">
                {{ nbVisitors }}
              </small>
              <v-icon :class="{'secondary--text' : '/trafic' == $route.matched[1].path}">explore</v-icon>
            </v-badge>
          </v-list-tile-action>
        </v-list-tile>
        <span>
          {{ $t('trafic') | cap }} {{ '(' + $tc('visitors', $store.state._StoreWatcheeBox.listeAllVisiteurs.length, { count: nbVisitors }) + ')' }}
        </span>
      </v-tooltip>
      <!-- STATISTIQUES -->
      <v-tooltip right v-if="checkPermission('NO_PEONS')">
        <v-list-tile
          :to="{path: '/stats/audience'}"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/stats' == $route.matched[1].path}"
        >
          <v-list-tile-action>
            <v-icon :class="{'secondary--text' : '/stats' == $route.matched[1].path}">assessment</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <span>{{ $t('stats') | cap }}</span>
      </v-tooltip>
      <!-- GESTION DES COMPTES (management) -->
      <v-tooltip right v-if="checkPermission('NO_AGENTS')">
        <v-list-tile
          :to="{path: '/management/agents'}"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/management' == $route.matched[1].path}"
        >
          <v-list-tile-action>
            <v-icon :class="{'secondary--text' : '/management' == $route.matched[1].path}">assignment_ind</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <span>{{ $t('management') | cap }}</span>
      </v-tooltip>

      <!-- GESTION DES FILTRES -->
      <v-tooltip right v-if="checkPermission('NO_AGENTS')">
        <v-list-tile
          :to="{path: '/target/filters'}"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/target' == $route.matched[1].path}"
        >
          <v-list-tile-action>
            <v-icon :class="{'secondary--text' : '/target' == $route.matched[1].path}">track_changes</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <span>{{ $t('filters') | cap }}</span>
      </v-tooltip>

      <!-- MEDIA -->
      <v-tooltip right>
        <v-list-tile
          :to="pathMedia"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/media' == $route.matched[1].path}"
        >
          <v-list-tile-action>
            <v-icon :class="{'secondary--text' : '/media' == $route.matched[1].path}">perm_media</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <span>{{ $t('media') | cap }}</span>
      </v-tooltip>

      <!-- PARAMÈTRES -->
      <v-tooltip right v-if="checkPermission('NO_AGENTS')">
        <v-list-tile
          :to="{path: '/settings/preview'}"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/settings' == $route.matched[1].path}"
        >
          <v-list-tile-action>
            <v-icon :class="{'secondary--text' : '/settings' == $route.matched[1].path}">settings</v-icon>
          </v-list-tile-action>
        </v-list-tile>     
        <span>{{ $t('settings') | cap }}</span>
      </v-tooltip>
    </v-list>
  </div>
</template>

<script>
import { LEVEL } from '../../constants'
import { mapState } from 'vuex'
export default {

  name: 'WzMenu',

  computed: {
    ...mapState('_User', ['hideTabVisitors', 'brides']),
    isLevelEntreprise () {
      return !(this.$store.getters['_User/level'].rights === LEVEL.ENTREPRISE)
    },
    nbVisitors () {
      return this.$store.state._StoreWatcheeBox.listeAllVisiteurs.length > 99
        ? '99+'
        : this.$store.state._StoreWatcheeBox.listeAllVisiteurs.length
    },
    pathTrafic () {
      let pathTrafic = {path: '/trafic/visitors'}
      // si la nav du haut n'est pas affiché c'est la ,page chatting par defaut
      if (this.hideTabVisitors) {
        pathTrafic = {path: '/trafic/chatting'}
      } else {
        // si le trafic visiteur n'est pas bridé
        // console.log(this.brideMenu('trafic_visiteurs'))
        if (Number(this.brideMenu('trafic_visiteurs'))) {
          // console.log('page visiteurs')
          pathTrafic = {path: '/trafic/visitors'}
        // sinon on test la page suivante
        } else if (Number(this.brideMenu('trafic_discussions'))) {
          // console.log('page chat')
          pathTrafic = {path: '/trafic/chatting'}
        }
      }
      return pathTrafic
    },
    pathMedia () {
      let pathMedia = {path: '/media/biblios'}
      // si la nav du haut n'est pas affiché c'est la ,page chatting par defaut
      if (Number(this.brideMenu('media_phrases'))) {
        pathMedia = {path: '/media/biblios'}
      } else {
        if (Number(this.brideMenu('media_push'))) {
          pathMedia = {path: '/media/pushs'}
        }
      }
      // console.log('pathMedia', pathMedia)
      return pathMedia
    }
  },

  methods: {
    // pour tester mais pas utilisé
    brideMenu (nameBride) {
      if (this.brides) {
        let index = this.brides.findIndex(bride => bride.brideName === nameBride)
        // console.log('index', index)
        if (index !== -1) {
          return this.brides[index].status
        }
      }
    }
  }
}
</script>

<style>
  /**
   * Mettre en évidence la route sur laquelle on se trouve
   */
  li.list__tile--active-router {
    background-color: rgba(0, 0, 0, 0.12);
  }
</style>




// WEBPACK FOOTER //
// src/components/watcheezy/WzMenu.vue